import { useRouteContext } from '@tanstack/react-router';
import { posthog } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import * as React from 'react';
import { UIProvider } from '@_/ui';
import { AppShellProvider } from './components/AppShell/index.ts';
import { I18nProvider } from './components/I18nProvider/index.ts';
import { SeoTags } from './components/SeoTags/index.ts';
import { AccessProvider } from './state/AccessContext.tsx';
import { StoreProvider } from './state/StoreContext.tsx';

export function App({
  children,
  i18nMessages,
  locale
}: React.PropsWithChildren<Parameters<typeof I18nProvider>[0]>) {
  const { useAuthStore } = useRouteContext({
    from: '__root__'
  });

  return (
    <PostHogProvider client={posthog}>
      <StoreProvider useAuthStore={useAuthStore}>
        <I18nProvider i18nMessages={i18nMessages} locale={locale}>
          <UIProvider>
            <AccessProvider>
              <AppShellProvider>
                <SeoTags title="SlashHow" useTitleTemplate={false} />
                {children}
              </AppShellProvider>
            </AccessProvider>
          </UIProvider>
        </I18nProvider>
      </StoreProvider>
    </PostHogProvider>
  );
}
